import '../asset/main.css'
import imagecover from '../asset/images/15.png'
import Close from 'remixicon-react/CloseLineIcon'
import Upload from 'remixicon-react/UploadCloudFillIcon'
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useState } from 'react'
import { useEffect, useRef } from 'react';

import { addMemory } from '../firebase'

import { ref, uploadBytes, getDownloadURL, uploadBytesResumable } from 'firebase/storage';

import { app, storage } from '../firebase'

export default function AddMemory({ onHideBox }) {
    const handleHideBox = () => {
        onHideBox();
    };
    const [startDate, setStartDate] = useState(new Date());
    const [progress, setProgress] = useState(0);
    const [dataMemory, setDataMemory] = useState({})
    useEffect(() => {
        const formatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
        const formattedEndDate = startDate.toLocaleDateString('en-US', formatOptions);
        setDataMemory({
            ...dataMemory,
            date: formattedEndDate,
        })
    }, [startDate])

    const [imgData, setImageData] = useState();
    const [avatar, setAvatar] = useState()

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        setAvatar(file)

        if (file) {
            const reader = new FileReader();
            reader.onload = () => {
                const dataURL = reader.result;
                setImageData(dataURL);
                console.log(imgData)
            };
            reader.readAsDataURL(file);
        }

    };
    const uploadImage = () => {
        if (avatar) {
            const storageRef = ref(storage, `imageMemory/${avatar.name}`);
            const uploadTask = uploadBytesResumable(storageRef, avatar);
            uploadTask.on(
                'state_changed',
                (snapshot) => {
                    const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    setProgress(progress);
                },
                (error) => {
                    console.error(error);
                },
                () => {
                    getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                        console.log('File available at', downloadURL);
                        setDataMemory({
                            ...dataMemory,
                            avatarProject: downloadURL
                        })
                    });
                }
            );
        } else {
            console.log('No image selected');
        }
    };
    const handlePostMemory = () => {
        addMemory(dataMemory)
            .then(() => {
                alert("Successfully!")
                onHideBox()
                window.location.reload()
            })
            .catch((error) => {
                console.log(error)
            })
    }
    return (
        <div className="addmem">
            <div className="button-close">
                <div className="wrap-button_close" onClick={handleHideBox}>
                    <Close size={40} color='#585858'></Close>
                </div>
            </div>
            <div className="wrap-addproject">

                <div className="addproject-left">
                    <div className="wrap-addproject-left">
                        <div className="addproject-left_name">
                            <h2>Title</h2>
                            <input type="text" onChange={(title) => {
                                setDataMemory({
                                    ...dataMemory,
                                    title: title.target.value
                                })
                            }} />
                        </div>
                        <div className="addproject-left_description">
                            <h2>Content</h2>
                            <textarea onChange={(content) => {
                                setDataMemory({
                                    ...dataMemory,
                                    content: content.target.value
                                })
                            }}></textarea>
                        </div>
                        <div className="addproject-left_uploadimg">
                            <div className="option-image_buttonup" onClick={uploadImage}>
                                <Upload color='#585858' size={34} ></Upload>
                            </div>
                            <div className="wrap-previewimage">
                                <h2>Image</h2>
                                <div className="wrap-previewimage_picture">
                                    <img src={imgData ? imgData : imagecover} alt="Preview" />
                                </div>
                                <div className="wrap-button-addfile">
                                    <input type="file"
                                        onChange={handleFileChange} />
                                    <div className="progress-bar" style={{ width: `${progress}%` }}>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="addproject-left_wrapdate-mem">
                            <div className="wrapdate-start">
                                <h2>Date</h2>
                                <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} />
                            </div>

                            <div className="wrap-button-memadd" onClick={handlePostMemory} >
                                <input type="button" value="Post" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}